import { useSelectedLocations } from '@frontend/payments-hooks';
import { useAppFlagStore } from '@frontend/shared';

export const useActiveFeatureLocationIds = (flagName: string) => {
  const { locationIds } = useSelectedLocations();

  const { getFeatureFlagLocationMap } = useAppFlagStore();
  const map = getFeatureFlagLocationMap({ flagName, locationIds });

  const activeLocationIds = Object.entries(map || {}).reduce((acc, [locationId, row]) => {
    if (row?.value) {
      acc.push(locationId);
    }

    return acc;
  }, [] as string[]);

  return activeLocationIds;
};
